export default __webpack_public_path__ + "locales/si/Payments.json?hash=beca887a97d98fada3a292e35e637f79";